var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-no-data"},[_c('div',{staticClass:"a-no-data__text"},[_vm._v(_vm._s(_vm.text))]),(this.$slots.default !== undefined)?_c('div',{staticClass:"a-no-data__item"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }